var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("navigation-drawer"),_c('v-main',[_c('v-container',[_vm._t("default")],2)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }